export default "__VITE_ASSET__Cw2hEgVu__"